<script setup>
import { ref, defineProps } from 'vue';
import ImageDropdownResultList from "./ImageDropdownResultList.vue"

const resultIsOpen = ref(false)
const itemSelect = ref(null)
const props = defineProps({
    elements: Array
})

function toggleDropdown() {
    resultIsOpen.value = !resultIsOpen.value
    
}

function itemIsClicked(element) {
    itemSelect.value = element
}

</script>

<template>
    <div class="dropdownInputContainer">
        <div class="dropdownElement d-flex align-items-center justify-content-center"  @click="toggleDropdown">
            <div class="itemResult" v-if="itemSelect">{{itemSelect.name}}</div>
            <div class="dropdownIcon" v-if="resultIsOpen">
                    <i class="fa-solid fa-chevron-up fa-lg"></i>
            </div>
            <div class="dropdownIcon" v-if="!resultIsOpen">
                    <i class="fa-solid fa-chevron-down fa-lg"></i>
            </div>
           
        </div>
        <ImageDropdownResultList :elements="props.elements" :resultIsOpen="resultIsOpen" @itemIsClicked="itemIsClicked" @isClicked="toggleDropdown" />
    </div>
</template>

<style scoped>

</style>